module.exports = __webpack_public_path__ + "img/menu_icon_user.8d67cd91.svg";